import { IconButton } from '@mui/material'
import { forwardRef, ForwardedRef } from 'react'
import { EastIcon } from '@weblite/icons'

interface Props {
  onClick: () => unknown
  color?: string
}

export const BackButton = forwardRef(function BackButton(
  { onClick, color }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <IconButton ref={ref} onClick={onClick}>
      <EastIcon sx={{ color: color || 'neutral900' }} />
    </IconButton>
  )
})
